<template lang="pug">
.event(id='event')
  .event__title МЕРОПРИЯТИЕ
  .event__top
    img.event__logo(src='../static/KV_v8_neoconf.svg')
    .event__top-text  — это
  .event__content
    .event__content-item(v-for="(item, index) in items" :key="index + ' event'")
      .event__count {{index+1}}
      .event__name {{item.name}}
      .event__text {{item.text}}
</template>

<script>
export default {
  name: 'event',
  data() {
    return {
      items: [
        {
          name: 'Новости',
          text: 'Мы расскажем о последних новостях компании и рынка MedTech',
        },
        {
          name: 'Общение',
          text:
            'Используйте встроенный чат рядом с плеером для общения с коллегами',
        },
        {
          name: 'Развлечение',
          text:
            'Дождитесь окончания деловой части и примите участие в первом музыкальном киберфесте',
        },
      ],
    };
  },
};
</script>

<style lang="sass">
.event
  padding: 90px 20px 104px
  max-width: 940px
  margin: 0 auto
  box-sizing: border-box
  @media screen and (max-width: 812px)
    padding: 40px 20px
    max-width: 375px
  &__title
    font-size: 16px;
    line-height: 19px;
    font-weight: bold
    letter-spacing: 2px;
    color: #FFFFFF;
    mix-blend-mode: normal;
    opacity: 0.3;
    margin-bottom: 80px
    @media screen and (max-width: 812px)
      text-align: center;
      margin-bottom: 40px
  &__top
    display: flex
    margin-bottom: 58px
    align-items: center
    transform: translateX(-29px);
    @media screen and (max-width: 812px)
      margin-bottom: 40px
      width: 100%
      transform: translateX(0)
    &-text
      font-size: 40px;
      line-height: 47px;
      color: #FFFFFF;
  &__logo
    width: 240px
    height: 81px
    margin-right: 5px
    @media screen and (max-width: 812px)
      margin-right: 0px
      width: 196px
      height: auto
      transform: translateY(2px)
  &__content
    display: flex
    @media screen and (max-width: 812px)
      flex-direction: column
    &-item
      display: flex
      flex-direction: column
      position: relative
      @media screen and (max-width: 812px)
        text-align: center
      &:not(:last-child)
        margin-right: 104px
        @media screen and (max-width: 812px)
          margin-right: 0
          margin-bottom: 40px
        &::before
          content: ''
          background: #FFFFFF
          position: absolute
          width: 170px
          height: 1px
          top: 36px;
          left: 85px;
          @media screen and (max-width: 812px)
            display: none
  &__count
    font-size: 60px;
    line-height: 70px;
    color: #FFFFFF;
    margin-bottom: 61px
    @media screen and (max-width: 812px)
      margin-bottom: 0
  &__name
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
    margin-bottom: 41px
    @media screen and (max-width: 812px)
      margin-bottom: 10px
  &__text
    font-size: 14px;
    line-height: 30px;
    color: #FFFFFF;
    mix-blend-mode: normal;
    opacity: 0.5;
    @media screen and (max-width: 812px)
      font-size: 15px;
      line-height: 22px;
</style>
